import httpService from "core/services/httpService";

import API_URL from "core/constants/api/apiUrl";

const autosuggestionService = {
    getAffiliates(params, signal){
        return httpService.get({
            url: API_URL.AUTOSUGGESTION_GET_AFFILIATES,
            signal,
            queryData: params
        }).then(({ data: { value } }) => {
            return value;
        })
    },

    getPostbacks(signal){
        return httpService.get({
            url: API_URL.AUTOSUGGESTION_GET_POSTBACKS,
            signal
        }).then(({ data: { value } }) => {
            return value;
        })
    },

    getCampaigns(data, signal){
        return httpService.get({
            url: API_URL.AUTOSUGGESTION_GET_CAMPAIGNS,
            signal,
            queryData: data
        }).then(({ data: { value } }) => {
            return value;
        })
    },

    getMedias(data, signal){
        return httpService.get({
            url: API_URL.AUTOSUGGESTION_GET_MEDIAS,
            signal,
            queryData: data
        }).then(({ data: { value } }) => {
            return value;
        })
    },

    getPlayers(params={}, signal){
        return httpService.get({
            url: API_URL.AUTOSUGGESTION_GET_PLAYERS,
            signal,
            queryData: params
        }).then(({ data: { value } }) => {
            return value;
        })
    },

    getBrands(signal){
        return httpService.get({
            url: API_URL.AUTOSUGGESTION_GET_BRANDS,
            signal
        }).then(({ data: { value } }) => {
            return value;
        })
    },

    getPromoCodes(params, signal){
        return httpService.get({
            url: API_URL.AUTOSUGGESTION_GET_PROMO_CODES,
            signal,
            queryData: params
        }).then(({ data: { value } }) => {
            return value;
        })
    },

    getLandingUrls(params, signal){
        return httpService.get({
            url: API_URL.AUTOSUGGESTION_GET_LANDING_URLS,
            signal,
            queryData: params
        }).then(({ data: { value } }) => {
            return value;
        })
    },

    getMobileUrls(params, signal){
        return httpService.get({
            url: API_URL.AUTOSUGGESTION_GET_MOBILE_URLS,
            signal,
            queryData: params
        }).then(({ data: { value } }) => {
            return value;
        })
    },

    getBrandLandingUrls(params, signal){
        return httpService.get({
            url: API_URL.AUTOSUGGESTION_GET_BRAND_LANDING_URLS,
            signal,
            queryData: params
        }).then(({ data: { value } }) => {
            return value;
        })
    },

    getBrandMobileUrls(params, signal){
        return httpService.get({
            url: API_URL.AUTOSUGGESTION_GET_BRAND_MOBILE_URLS,
            signal,
            queryData: params
        }).then(({ data: { value } }) => {
            return value;
        })
    },

    getBrandDomains(params, signal){
        return httpService.get({
            url: API_URL.AUTOSUGGESTION_GET_BRAND_DOMAINS,
            signal,
            queryData: params
        }).then(({ data: { value } }) => {
            return value;
        })
    },

    getTrafficSources(params, signal){
        return httpService.get({
            url: API_URL.AUTOSUGGESTION_GET_TRAFFIC_SOURCES,
            signal,
            queryData: params
        }).then(({ data: { value } }) => {
            return value;
        })
    },

    getProjects(params, signal){
        return httpService.get({
            url: API_URL.AUTOSUGGESTION_GET_PROJECTS,
            signal,
            queryData: params
        }).then(({ data: { value } }) => {
            return value;
        })
    },

    getUsers(params, signal){
        return httpService.get({
            url: API_URL.AUTOSUGGESTION_GET_USERS,
            signal,
            queryData: params
        }).then(({ data: { value } }) => {
            return value;
        })
    },

    getAffiliateManagers(params, signal){
        return httpService.get({
            url: API_URL.AUTOSUGGESTION_GET_AFFILIATE_MANAGERS,
            signal,
            queryData: params
        }).then(({ data: { value } }) => {
            return value;
        })
    },

    getFinancialManagers(params, signal){
        return httpService.get({
            url: API_URL.AUTOSUGGESTION_GET_FINANCIAL_MANAGERS,
            signal,
            queryData: params
        }).then(({ data: { value } }) => {
            return value;
        })
    },

    getAccessManagers(params, signal) {
        return httpService.get({
            url: API_URL.AUTOSUGGESTION_GET_ACCESS_MANAGERS,
            signal,
            queryData: params
        }).then(({ data: { value } }) => {
            return value;
        })
    },

    getPermissionGroups(params, signal) {
        return httpService.get({
            url: API_URL.AUTOSUGGESTION_GET_PERMISSION_GROUPS,
            signal,
            queryData: params
        }).then(({ data: { value } }) => {
            return value;
        })
    },

    getProjectPaymentMethods(params, signal){
        return httpService.get({
            url: API_URL.AUTOSUGGESTION_GET_PROJECT_PAYMENT_METHODS,
            signal,
            queryData: params
        }).then(({ data: { value } }) => {
            return value;
        })
    },
}

export default autosuggestionService;